import Vue from 'vue'

// 全局事件总线，用于跨模块通信（例如：在axios拦截器中触发登录弹窗）
const eventBus = new Vue()

export default eventBus



